/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from "@ember/object";
import Component from "@glimmer/component";
import type { EmberChangeset } from "ember-changeset";
import type { ProtocolSectionArgs } from "../../base-components/base-protocol-item";
import { updateFollowingCureDate } from "../../utils/protocol-helpers";

export default class ProtocolsViewRegorafenibStivargaInitialComponent extends Component<ProtocolSectionArgs> {
  @action
  onChangesetUpdate(changeset: EmberChangeset, propertyName: string) {
    if (propertyName?.includes("Date")) {
      updateFollowingCureDate({
        changeset: this.args.changeset,
        propertyName,
        numberOfCures: 7,
        timeUnit: "month",
        timeValue: 1
      });
    }

    if (!this.args.protocolModel.isPaused) {
      this.args.changeset.set("pause-date", null);
      this.args.changeset.set("pause-time-frequency-value", null);
      this.args.changeset.set("pause-time-frequency-unit", null);
    }

    this.args.onChangesetUpdate(changeset);
  }
}
